<!-- Selecionar todos (oculto para seleção única: atividade/EJA modular) -->
<div
  *ngIf="!selecaoUnica"
  (click)="enabled && toggleTodosComponentes()"
  [class.opacity-50]="!enabled"
  [class.cursor-not-allowed]="!enabled"
  class="flex items-center gap-3 cursor-pointer hover:bg-blue-50 dark:hover:bg-blue-900/20 px-4 py-2.5 rounded-lg transition-all duration-200 mb-2 border border-transparent hover:border-blue-200 dark:hover:border-blue-800"
>
  <lucide-icon
    [img]="todosComponentesSelecionados() ? CheckSquareIcon : SquareIcon"
    class="w-5 h-5 text-blue-600 dark:text-blue-400 flex-shrink-0"
  ></lucide-icon>
  <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Selecionar todos os componentes</span>
</div>

<!-- Lista de componentes -->
<div class="border-2 border-gray-200 dark:border-gray-600 rounded-xl max-h-60 overflow-y-auto bg-white dark:bg-gray-700 shadow-sm"
     [class.opacity-50]="!enabled"
     [class.pointer-events-none]="!enabled">
  <div
    *ngFor="let componente of componentes; let i = index"
    class="flex items-center px-4 py-2 hover:bg-gray-50 dark:hover:bg-gray-600 border-b border-gray-100 dark:border-gray-600 last:border-b-0 cursor-pointer transition-all duration-150"
    (click)="enabled && toggleComponente(componente)"
  >
    <input
      [type]="selecaoUnica ? 'radio' : 'checkbox'"
      [checked]="componente.selected"
      name="componenteCurricular"
      class="w-4 h-4 text-blue-600 accent-blue-600 border-gray-300 dark:border-gray-500 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 cursor-pointer transition-all"
      [class.rounded]="!selecaoUnica"
      (click)="$event.stopPropagation()"
      (change)="toggleComponente(componente)"
    >
    <div class="flex items-center ml-3 flex-1 min-w-0 gap-2.5">
      <div
        class="w-3 h-3 rounded-full flex-shrink-0 shadow-sm"
        [style.background-color]="getComponenteColor(i)"
      ></div>
      <span class="text-sm text-gray-900 dark:text-gray-100 break-words leading-relaxed">{{ componente.descricao || componente.nome }}</span>
    </div>
  </div>
</div>
